module.exports = __webpack_public_path__ + "b77fea1eaddb100f43bfe3b0b3ceaf69.pdf";